"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDidUnmount = void 0;
var react_1 = require("react");
function useDidUnmount(fn) {
    react_1.useEffect(function () {
        return fn;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
exports.useDidUnmount = useDidUnmount;
